import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	margin-right: 20px;
`;

const StyledHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: calc(100% - 20px);
`;

const StyledPropertyContainer = styled.div`
	width: 100%;
	height: 720px;
	padding-right: 10px;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		width: 10px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: rgba(255, 255, 255, 0.1);

		&:hover {
			background-color: rgba(255, 255, 255, 1);
		}
	}
`;

export { StyledContainer, StyledHead, StyledPropertyContainer };
